// import React, { useEffect, useState } from "react";
// import createInstance from "../../../api/axiosinstance";

// const MockDash = ({ skillCount }) => {
//   const [users, SetUsers] = useState([]);
//   const [skillsCount, SetSkillCount] = useState();
//   const [roles, setRoles] = useState([]);
//   const [orgList, setOrgList] = useState([]);
//   const [jobsBySkills, setJobsBySkills] = useState([]);
//   const aiDisha = createInstance("DISHA");

//   useEffect(() => {
//     Dashboard();
//     fetchUsers();
//     fetchSkillsCount();
//     fetchRoleCount();
//     getOrgList();
//   }, []);
//   const Dashboard = async () => {
//     try {
//       const response = await aiDisha.get("/Admin_Dashboard_values/");
//       console.log("dashboard", response.data);
//       setJobsBySkills(response.data.Active_Jobs_by_Skills);
//     } catch (error) {
//       console.log("error", error);
//     }
//   };
//   const fetchUsers = async () => {
//     try {
//       const response = await aiDisha.get("/get-all-users");
//       console.log("all userz", response);
//       SetUsers(response.data.All_users);
//       console.log("all userz", response.data.All_users);
//     } catch (error) {
//       console.log(error);
//     }
//   };
//   const fetchSkillsCount = async () => {
//     try {
//       const response = await aiDisha.get("/skills-show/active");
//       if (response.data) {
//         SetSkillCount(response.data.count || 0);
//         console.log("skills", response);
//       }
//     } catch (error) {
//       console.error("Error fetching skills for dropdown:", error.message);
//     }
//   };
//   const fetchRoleCount = async () => {
//     try {
//       const response = await aiDisha.get("/get-all-active-admin-roles/");
//       if (response.data) {
//         setRoles(response.data);
//         console.log("Roles", response);
//       }
//     } catch (error) {
//       console.error("Error fetching roles:", error.message);
//     }
//   };
//   const getOrgList = async () => {
//     await aiDisha
//       .get("/get-all-active-organizations?status=Active")
//       .then((response) => {
//         setOrgList(response.data);
//         console.log("ORG LIST : ", response.data);
//       })
//       .catch((error) => {
//         console.log("Error fetching active organizations", error);
//       });
//   };
//   return (
//     <div style={{ boxShadow: "-16px -9px 19px -8px rgba(0,0,0,0.75)" }}>
//       <svg
//         width="100%"
//         height="100%"
//         viewBox="0 0 1200 800"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <defs>
//           <linearGradient id="d" x1="0" y1="0" x2="0" y2="1">
//             <stop offset="5%" stop-color="#4d79ff" stop-opacity=".5" />
//             <stop offset="95%" stop-color="#6989e0" stop-opacity=".5" />
//           </linearGradient>
//           <filter id="b">
//             <feGaussianBlur in="SourceGraphic" stdDeviation="5" result="blur" />
//             <feColorMatrix
//               in="blur"
//               values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 0.2 -0.1"
//               result="glass"
//             />
//           </filter>
//           <filter id="c" width="150%" height="150%">
//             <feGaussianBlur stdDeviation="4" result="blur" />
//             <feComposite in="SourceGraphic" in2="blur" />
//           </filter>
//         </defs>
//         <rect width="100%" height="100%" fill="#ffffff" />

//         <g transform="translate(60 50)">
//           <rect
//             width="170"
//             height="120"
//             rx="12"
//             fill="rgba(244, 249, 233, 0.8)"
//             filter="url(#b)"
//             stroke="#4d79ff"
//             stroke-opacity=".3"
//           />
//           <circle cx="30" cy="30" r="30" fill="#4d79ff" filter="url(#c)" />
//           <text
//             x="30"
//             y="35"
//             font-family="Arial"
//             font-size="30"
//             fill="#fff"
//             text-anchor="middle"
//           >
//             👥
//           </text>
//           <text x="70" y="20" font-family="Arial" font-size="16" fill="#000000">
//             Total Users
//           </text>
//           <text x="70" y="50" font-family="Arial" font-size="24" fill="#000000">
//             {users.length}
//           </text>
//           <text x="70" y="75" font-family="Arial" font-size="10" fill="#19a651">
//             ↑ 12%
//           </text>
//           <rect
//             x="190"
//             width="170"
//             height="120"
//             rx="12"
//             fill="rgba(244, 249, 233, 0.8)"
//             filter="url(#b)"
//             stroke="#ff4757"
//             stroke-opacity=".3"
//           />
//           <circle cx="250" cy="25" r="30" fill="#ff4757" filter="url(#c)" />
//           <text
//             x="250"
//             y="35"
//             font-family="Arial"
//             font-size="30"
//             fill="#fff"
//             text-anchor="middle"
//           >
//             📊
//           </text>
//           <text
//             x="300"
//             y="20"
//             font-family="Arial"
//             font-size="16"
//             fill="#000000"
//           >
//             Active Skills
//           </text>
//           <text
//             x="300"
//             y="50"
//             font-family="Arial"
//             font-size="24"
//             fill="#000000"
//           >
//             {skillsCount || 87}
//           </text>
//           <text
//             x="300"
//             y="75"
//             font-family="Arial"
//             font-size="10"
//             fill="#19a651"
//           >
//             ↑ 5
//           </text>
//           <rect
//             x="380"
//             width="170"
//             height="120"
//             rx="12"
//             fill="rgba(244, 249, 233, 0.8)"
//             filter="url(#b)"
//             stroke="#4dff88"
//             stroke-opacity=".3"
//           />
//           <circle cx="500" cy="25" r="30" fill="#4dff88" filter="url(#c)" />
//           <text
//             x="500"
//             y="35"
//             font-family="Arial"
//             font-size="30"
//             fill="#fff"
//             text-anchor="middle"
//           >
//             👔
//           </text>
//           <text
//             x="550"
//             y="20"
//             font-family="Arial"
//             font-size="16"
//             fill="#000000"
//           >
//             Active Roles
//           </text>
//           <text
//             x="550"
//             y="50"
//             font-family="Arial"
//             font-size="24"
//             fill="#000000"
//           >
//             {roles.length}
//           </text>
//           <text
//             x="550"
//             y="75"
//             font-family="Arial"
//             font-size="10"
//             fill="#ff4757"
//           >
//             ↓ 2
//           </text>
//           <rect
//             x="570"
//             width="170"
//             height="120"
//             rx="12"
//             fill="rgba(244, 249, 233, 0.8)"
//             filter="url(#b)"
//             stroke="#ffd166"
//             stroke-opacity=".3"
//           />
//           <circle cx="730" cy="25" r="30" fill="#ffd166" filter="url(#c)" />
//           <text
//             x="730"
//             y="35"
//             font-family="Arial"
//             font-size="30"
//             fill="#fff"
//             text-anchor="middle"
//           >
//             🏢
//           </text>
//           <text
//             x="780"
//             y="20"
//             font-family="Arial"
//             font-size="16"
//             fill="#000000"
//           >
//             Organizations
//           </text>
//           <text
//             x="780"
//             y="50"
//             font-family="Arial"
//             font-size="24"
//             fill="#000000"
//           >
//             {orgList.length}
//           </text>
//           <text
//             x="780"
//             y="75"
//             font-family="Arial"
//             font-size="10"
//             fill="#19a651"
//           >
//             ↑ 3
//           </text>
//         </g>
//         <g transform="translate(60 220)">
//           <rect
//             width="400"
//             height="250"
//             rx="12"
//             fill="rgba(244, 249, 233, 0.8)"
//             filter="url(#b)"
//           />
//           <text x="30" y="30" font-family="Arial" font-size="20" fill="#000000">
//             Active Jobs by Skills
//           </text>
//           {jobsBySkills.map((item, index) => (
//             <React.Fragment key={index}>
//               <rect
//                 x={40 + index * 70}
//                 y={200 - item.job_count * 15}
//                 width="60"
//                 height={item.job_count * 15}
//                 fill="url(#d)"
//                 rx="4"
//               />
//               <text
//                 x={70 + index * 70}
//                 y="245"
//                 font-family="Arial"
//                 font-size="13"
//                 fill="#000000"
//                 text-anchor="middle"
//               >
//                 {item.skill}
//               </text>
//             </React.Fragment>
//           ))}
//           <rect
//             x="380"
//             width="360"
//             height="220"
//             rx="12"
//             fill="rgba(244, 249, 233, 0.8)"
//             filter="url(#b)"
//           />
//           <text
//             x="500"
//             y="30"
//             font-family="Arial"
//             font-size="20"
//             fill="#000000"
//           >
//             Top Required Skills
//           </text>
//           <circle cx="610" cy="120" r="60" fill="#4d79ff" fill-opacity=".6" />
//           <path
//             d="M610 60a60 60 0 0 1 30 60h-30Z"
//             fill="#4dff88"
//             fill-opacity=".6"
//           />
//           <path
//             d="M610 60a60 60 0 0 0-30 60h30Z"
//             fill="#ff4757"
//             fill-opacity=".6"
//           />
//           <text
//             x="490"
//             y="160"
//             font-family="Arial"
//             font-size="13"
//             fill="#000000"
//           >
//             Linux: 38%
//           </text>
//           <text
//             x="490"
//             y="180"
//             font-family="Arial"
//             font-size="13"
//             fill="#000000"
//           >
//             AWS: 32%
//           </text>
//           <text
//             x="490"
//             y="200"
//             font-family="Arial"
//             font-size="13"
//             fill="#000000"
//           >
//             Python: 30%
//           </text>
//           <rect
//             width="720"
//             height="120"
//             rx="12"
//             fill="rgba(244, 249, 233, 0.8)"
//             filter="url(#b)"
//           />
//           <text
//             x="750"
//             y="30"
//             font-family="Arial"
//             font-size="20"
//             fill="#000000"
//           >
//             Candidate Pipeline
//           </text>
//           <rect x="750" y="180" width="60" height="40" fill="url(#d)" rx="4" />
//           <rect x="850" y="160" width="60" height="60" fill="url(#d)" rx="4" />
//           <rect x="950" y="140" width="60" height="80" fill="url(#d)" rx="4" />
//           <rect
//             x="1050"
//             y="120"
//             width="60"
//             height="100"
//             fill="url(#d)"
//             rx="4"
//           />
//           <text
//             x="790"
//             y="245"
//             font-family="Arial"
//             font-size="11"
//             fill="#000000"
//             text-anchor="middle"
//           >
//             Screening (120)
//           </text>
//           <text
//             x="890"
//             y="245"
//             font-family="Arial"
//             font-size="11"
//             fill="#000000"
//             text-anchor="middle"
//           >
//             Technical (80)
//           </text>
//           <text
//             x="990"
//             y="245"
//             font-family="Arial"
//             font-size="11"
//             fill="#000000"
//             text-anchor="middle"
//           >
//             Final (30)
//           </text>
//           <text
//             x="1080"
//             y="245"
//             font-family="Arial"
//             font-size="11"
//             fill="#000000"
//             text-anchor="middle"
//           >
//             Hired (10)
//           </text>
//         </g>
//       </svg>
//     </div>
//   );
// };

// export default MockDash;






















import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Chip,
  Stack,
  Alert,
  Skeleton,
  Divider,
  useTheme,
} from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import createInstance from "../../../api/axiosinstance";

const MockDash = () => {
  const theme = useTheme();
  const aiDisha = createInstance("DISHA");

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchDashboard = async () => {
      try {
        setLoading(true);
        const response = await aiDisha.get("/Admin_Dashboard_values/");
        setData(response.data);
      } catch (err) {
        console.error("Error fetching dashboard values:", err);
        setError("Unable to load dashboard data at the moment.");
      } finally {
        setLoading(false);
      }
    };

    fetchDashboard();
  }, []);

  const metrics = [
    {
      label: "Total Users",
      key: "total_active_users",
      value: data?.total_active_users ?? 0,
      trend: "+12%",
      trendType: "up",
    },
    {
      label: "Active Skills",
      key: "total_active_skills",
      value: data?.total_active_skills ?? 0,
      trend: "+5",
      trendType: "up",
    },
    {
      label: "Active Roles",
      key: "total_active_roles",
      value: data?.total_active_roles ?? 0,
      trend: "-2",
      trendType: "down",
    },
    {
      label: "Organizations",
      key: "total_active_org",
      value: data?.total_active_org ?? 0,
      trend: "+3",
      trendType: "up",
    },
  ];

  const jobsBySkills = data?.Active_Jobs_by_Skills ?? [];

  // Static candidate pipeline (until backend exposes it)
  const candidatePipeline = [
    { stage: "Screening", count: 120 },
    { stage: "Technical", count: 80 },
    { stage: "Final", count: 30 },
    { stage: "Hired", count: 10 },
  ];

  const renderMetricSkeleton = () => (
    <Grid container spacing={2} mb={3}>
      {Array.from({ length: 4 }).map((_, idx) => (
        <Grid item xs={12} sm={6} md={3} key={idx}>
          <Card sx={{ borderRadius: 3 }}>
            <CardContent>
              <Skeleton variant="text" width={80} />
              <Skeleton variant="text" width={60} sx={{ mt: 1 }} />
              <Skeleton variant="rectangular" height={24} sx={{ mt: 2 }} />
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );

  const renderBottomSkeleton = () => (
    <>
      {/* Row 2 skeleton – Active Jobs by Skills full width */}
      <Grid container spacing={2} mb={2}>
        <Grid item xs={12}>
          <Card sx={{ borderRadius: 3, height: 320 }}>
            <CardContent>
              <Skeleton variant="text" width={180} />
              <Skeleton
                variant="rectangular"
                height={240}
                sx={{ mt: 2, borderRadius: 2 }}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Row 3 skeleton – Skills snapshot & Candidate pipeline side by side */}
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Card sx={{ borderRadius: 3, height: 260 }}>
            <CardContent>
              <Skeleton variant="text" width={150} />
              <Skeleton
                variant="rectangular"
                height={190}
                sx={{ mt: 2, borderRadius: 2 }}
              />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card sx={{ borderRadius: 3, height: 260 }}>
            <CardContent>
              <Skeleton variant="text" width={150} />
              <Skeleton
                variant="rectangular"
                height={190}
                sx={{ mt: 2, borderRadius: 2 }}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );

  return (
    <Box
      sx={{
        p: 3,
        bgcolor: (theme) =>
          theme.palette.mode === "light" ? "#f5f7fb" : "background.default",
        minHeight: "100%",
      }}
    >
      {/* Error state */}
      {!loading && error && (
        <Box mb={2}>
          <Alert severity="error" variant="outlined">
            {error}
          </Alert>
        </Box>
      )}

      {/* Row 1: Top metrics */}
      {loading ? (
        renderMetricSkeleton()
      ) : (
        <Grid container spacing={2} mb={3}>
          {metrics.map((metric) => (
            <Grid item xs={12} sm={6} md={3} key={metric.key}>
              <Card
                sx={{
                  borderRadius: 3,
                  boxShadow: 4,
                  height: "100%",
                }}
              >
                <CardContent>
                  <Stack direction="row" justifyContent="space-between">
                    <Typography
                      variant="body2"
                      color="text.primary"
                      fontWeight={500}
                    >
                      {metric.label}
                    </Typography>
                    <Chip
                      size="small"
                      label={metric.trend}
                      color={
                        metric.trendType === "up"
                          ? "success"
                          : metric.trendType === "down"
                          ? "error"
                          : "default"
                      }
                      variant="soft"
                      sx={{
                        fontSize: 11,
                        borderRadius: "999px",
                      }}
                    />
                  </Stack>

                  <Typography
                    variant="h4"
                    sx={{ mt: 1 }}
                    fontWeight={700}
                    color="text.primary"
                  >
                    {metric.value}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      {/* Row 2 + Row 3 */}
      {loading ? (
        renderBottomSkeleton()
      ) : (
        <>
          {/* Row 2: Active Jobs by Skills (full width) */}
          <Grid container spacing={2} mb={2} >
            <Grid item xs={12}>
              <Card
                sx={{
                  borderRadius: 3,
                  boxShadow: 4,
                  height: 320,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <CardContent
                  sx={{ flex: 1, display: "flex", flexDirection: "column" }}
                >
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                  >
                    <Box>
                      <Typography
                        variant="subtitle1"
                        fontWeight={600}
                        sx={{ color: "black" }}
                      >
                        Active Jobs by Skills
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Jobs distribution across key skill sets
                      </Typography>
                    </Box>
                  </Stack>

                  {jobsBySkills.length === 0 ? (
                    <Box
                      sx={{
                        flex: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography variant="body2" color="text.secondary">
                        No active jobs by skills yet.
                      </Typography>
                    </Box>
                  ) : (
                    <Box sx={{ flex: 1 }}>
                      <ResponsiveContainer width="100%" height="100%">
                        <BarChart
                          data={jobsBySkills}
                          margin={{ top: 8, right: 8, bottom: 24, left: 0 }}
                        >
                          <CartesianGrid
                            strokeDasharray="3 3"
                            vertical={false}
                            stroke={
                              theme.palette.mode === "light"
                                ? "#e5e7eb"
                                : "#374151"
                            }
                          />
                          <XAxis
                            dataKey="skill"
                            tick={{ fontSize: 11 }}
                            tickMargin={8}
                            fill="#6366f1"
                          />
                          <YAxis
                            allowDecimals={false}
                            tick={{ fontSize: 11 }}
                          />
                          <Tooltip
                            contentStyle={{
                              fontSize: 12,
                              borderRadius: 8,
                            }}
                          />
                          <Bar
                            dataKey="job_count"
                            radius={[6, 6, 0, 0]}
                            fill={theme.palette.primary.main}
                          />
                        </BarChart>
                      </ResponsiveContainer>
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          {/* Row 3: Skills Snapshot (left) & Candidate Pipeline (right) */}
          <Grid container spacing={2}>
            {/* Skills Snapshot */}
            <Grid item xs={12} md={6}>
              <Card
                sx={{
                  borderRadius: 3,
                  boxShadow: 4,
                  height: 260,
                }}
              >
                <CardContent sx={{ pb: 1.5, height: "100%" }}>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={1}
                  >
                    <Typography variant="subtitle1" fontWeight={600} sx={{color:"black"}}>
                      Skills Snapshot
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Total skills: {data?.total_active_skills ?? 0}
                    </Typography>
                  </Stack>

                  <Divider sx={{ mb: 1.5 }} />

                  {jobsBySkills.length === 0 ? (
                    <Typography variant="body2" color="text.secondary">
                      Skills will surface here as jobs are created.
                    </Typography>
                  ) : (
                    <Box
                      sx={{
                        maxHeight: 180,
                        overflowY: "auto",
                        pr: 1,
                      }}
                    >
                      {jobsBySkills.map((item, idx) => (
                        <Box
                          key={item.skill}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            py: 0.75,
                            borderBottom:
                              idx === jobsBySkills.length - 1
                                ? "none"
                                : `1px solid ${
                                    theme.palette.mode === "light"
                                      ? "#e5e7eb"
                                      : "#374151"
                                  }`,
                                  
                          }}
                        >
                          <Typography
                            variant="body2"
                            fontWeight={500}
                            color="text.primary"
                          >
                            {item.skill}
                          </Typography>
                          <Chip
                            size="small"
                            label={`${item.job_count} job${
                              item.job_count > 1 ? "s" : ""
                            }`}
                            variant="outlined"
                          />
                        </Box>
                      ))}
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Grid>

            {/* Candidate Pipeline */}
            <Grid item xs={12} md={6}>
              <Card
                sx={{
                  borderRadius: 3,
                  boxShadow: 4,
                  height: 260,
                }}
              >
                <CardContent>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={1}
                  >
                    <Typography variant="subtitle1" fontWeight={600} sx={{color:"black"}}>
                      Candidate Pipeline
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Funnel view (static)
                    </Typography>
                  </Stack>

                  <Divider sx={{ mb: 1.5 }} />

                  <Stack spacing={1.25}>
                    {candidatePipeline.map((stage) => {
                      const max = candidatePipeline[0].count || 1;
                      const widthPercent = (stage.count / max) * 100;
                      return (
                        <Box key={stage.stage}>
                          <Stack
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                            mb={0.5}
                          >
                            <Typography
                              variant="body2"
                              color="text.primary"
                              fontWeight={500}
                            >
                              {stage.stage}
                            </Typography>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              {stage.count} candidates
                            </Typography>
                          </Stack>
                          <Box
                            sx={{
                              width: "100%",
                              height: 8,
                              borderRadius: 999,
                              bgcolor:
                                theme.palette.mode === "light"
                                  ? "#e5e7eb"
                                  : "#111827",
                              overflow: "hidden",
                            }}
                          >
                            <Box
                              sx={{
                                width: `${widthPercent}%`,
                                height: "100%",
                                bgcolor: theme.palette.primary.main,
                              }}
                            />
                          </Box>
                        </Box>
                      );
                    })}
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </>
      )}
    </Box>
  );
};

export default MockDash;
